const groupLatestLanguageCodeKey = "groupLatestLanguageCodeKey";

export function initializeGroupSettings() {
  localStorage.removeItem(groupLatestLanguageCodeKey);
}

export function getGroupLatestLanguageCode(): string | null {
  const languageCode = localStorage.getItem(groupLatestLanguageCodeKey);
  return languageCode;
}

export function setGroupLatestLanguageCode(code: string) {
  localStorage.setItem(groupLatestLanguageCodeKey, code);
}
